<template>
  <div class="adviceitem" v-for="item in adviceItem" :key="item.advID">
    <ul>
      <li>
        <RouterLink
          target="_blank"
          :to="`/advice/advicedetail?advID=${item.advID}&clID=${item.clID}`"
          >{{ item.advName }}
        </RouterLink>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    adviceItem: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.adviceitem {
  background: #fff;
  ul {
    & :hover {
      color: @shColor;
    }
    li {
      height: 50px;
      font-size: 15px;
      line-height: 50px;
      padding-left: 50px;
      border-bottom: 1px solid #dedede;
      width: 830px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      //background: #dedede;
    }
  }
}
</style>
